import Button from "../components/Button";
import { ContentWork } from "../components/ContentWork"
import TestImage from "../assets/panel_surya_rent.jpg"
import Video from "../assets/profile_panel_surya.mp4"
import { Link } from "react-router-dom"

export default function SewaMilikPanel(params) {
    return (
        <>
        <div>
                <div className="lg:mx-16 p-2">
                    <div className="lg:flex lg:max-w-full mb-5 w-full">
                        <div className="lg:p-6 lg:ml-8 lg:w-1/2  p-4">
                            <div> 
                                <h2 className="mb-2 text-4xl font-bold text-gray-900">Program Sewa Milik Panel Surya</h2>
                                <h2 className="mb-2 text-2xl font-normal text-gray-900">Kami memasangkan panel surya tanpa biaya dengan penghematan biaya listrik di bulan berikutnya.</h2>
                            </div>
                            <div className="mb-5">
                                <li>
                                    Tidak ada investasi di awal.
                                </li>
                                <li>
                                    Nikmati penghematan biaya listrik dari bulan pertama pemasangan.
                                </li>
                                <li>
                                    Aset akan menjadi milik Anda pada akhir kontrak.
                                </li>
                            </div>
                            <Link to="/formulir-sewa-panel">
                                <Button
                                    type="button"
                                    buttonStyle="bg-black w-1/4"
                                    onClick={() => console.log("You clicked on the pink circle!")}
                                    children="Mulai"
                                />
                            </Link>
                        </div>
                        <img src={TestImage} alt=''
                            className="w-1/1 lg:w-1/3 lg:h-100 rounded-md" />
                    </div>
                </div>
                <div className="bg-blue-400 h-1/2 w-full mt-20 p-1 lg:p-7">
                    <div className="mx-8 my-20 p-4 lg:flex lg:max-w-full">
                        <div className="text-white text-3xl w-full lg:w-1/2 lg:text-5xl">
                            Apa itu Program Sewa Milik Panel Surya?
                        </div>
                        <div className="w-full mt-8 lg:w-1/2 lg:mt-0">
                            <video controls src={Video} type="video/mp4" />
                        </div>
                    </div>
                </div>
                <div className="bg-white">
                    <div className="mx-16">
                        <div className="text-black text-3xl w-full lg:w-1/2 lg:p-4">
                            <p className="lg:my-8 my-6">Apa yang dimaksud dengan Sewa Milik?</p>
                        </div>
                        <div>
                            <ContentWork
                                title="Penilaian Energi"
                                subtitle="Langkah pertama"
                                description="Kami menilai penggunaan dan biaya listrik Anda saat ini untuk menentukan sistem ukuran apa yang dibutuhkan tempat Anda dan berapa banyak Anda akan menghemat biaya listrik."
                            />
                            <ContentWork
                                title="Instalasi"
                                subtitle="Langkah kedua"
                                description="Kami berkoordinasi dengan pemilik gedung untuk memasang panel surya di tempat Anda."
                            />
                            <ContentWork
                                title="Mulailah Menghemat!"
                                subtitle="Langkah ketiga"
                                description="Mulai melihat tagihan listrik bulanan yang lebih rendah dari perusahaan utilitas selama Anda menempati tempat tersebut."
                            />
                            <ContentWork
                                title="Pemutusan Kontrak?"
                                subtitle="Langkah keempat"
                                description="Ketika Anda memutuskan untuk mengosongkan tempat, Energi Masa Depan akan menghapus susunan surya. Tidak ada biaya, kewajiban, atau penalti."
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-blue-400 h-1/2 w-full mt-12 p-7">
                    <div className="mx-8 my-20 p-4 w-full lg:w-1/2 ">
                        <div className="text-white text-2xl mb-6">
                            Bagaimana Keuntungan Bisnis Anda?
                        </div>
                        <Button
                            type="button"
                            buttonStyle="bg-green-600 w-1/4"
                            onClick={() => console.log("You clicked on the pink circle!")}
                            children="Mulai"
                        />
                    
                    </div>
                </div>
        </div>
        </>
    )
}